import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
/**
 * Created by jahidul.hasan on 2/6/2020.
 */
@Injectable()
export class CollaborationService {
  constructor(private router: Router) {
  }

  navigateToSource(sourceType, sourceInfo) {
    if (sourceType === 'OrbitaxSupport') {
      if (sourceInfo && sourceInfo.sourceInfoDictionary && sourceInfo.sourceInfoDictionary.length >= 2) {
        if (sourceInfo.sourceInfoDictionary[1] && sourceInfo.sourceInfoDictionary[1].Value) {
          this.router.navigate([`${sourceInfo.sourceInfoDictionary[1].Value}`]).then(() => {
            window.location.reload();
          });
        }
      }
    } else if (sourceType === 'DAC6') {
      if (sourceInfo && sourceInfo.sourceInfoDictionary && sourceInfo.sourceInfoDictionary.length >= 2) {
        if (sourceInfo.sourceInfoDictionary[0] && sourceInfo.sourceInfoDictionary[0].Value) {
          this.router.navigate([`dac6-reporter/overview/case/${sourceInfo.sourceInfoDictionary[0].Value}`]);
        }
      }
    } else if ( sourceType === 'DAC6Form') {
      if (sourceInfo && sourceInfo.sourceInfoDictionary && sourceInfo.sourceInfoDictionary.length >= 3) {
        if (sourceInfo.sourceInfoDictionary[2] && sourceInfo.sourceInfoDictionary[2].Value) {
          this.router.navigate([sourceInfo.sourceInfoDictionary[2].Value]);
        }
      } else if (sourceInfo && sourceInfo.sourceInfoDictionary && sourceInfo.sourceInfoDictionary.length >= 2) {
        if (sourceInfo.sourceInfoDictionary[0] && sourceInfo.sourceInfoDictionary[0].Value) {
          this.router.navigate([`dac6-reporter/filing-manager/forms/${sourceInfo.sourceInfoDictionary[0].Value}`]);
        }
      }
    }
  }
}
